// extracted by mini-css-extract-plugin
module.exports = {"message":"styles_message__2j61M"};